module.exports = __webpack_public_path__ + "d62eb517e4c02616d0ce697b012e3e0e.svg";